import { useRef } from 'react';
import { createBookingStore } from './bookingStore';
import { BookingStoreContext } from './bookingStoreContext';
import type { BookingStore } from './bookingStoreType';

interface BookingStoreProviderProps {
  storeName: string;
  children: React.ReactNode;
}

export const BookingStoreProvider = ({ storeName, children }: BookingStoreProviderProps) => {
  const storeRef = useRef<BookingStore | undefined>(undefined);

  // eslint-disable-next-line react-hooks/refs -- lazy one-time init of the per-provider zustand store; ref is written once on first render and never changes
  if (!storeRef.current) {
    storeRef.current = createBookingStore({ storeName });
  }

  // eslint-disable-next-line react-hooks/refs -- ref holds the store created once above; its value is stable for the provider lifetime
  return <BookingStoreContext.Provider value={storeRef.current}>{children}</BookingStoreContext.Provider>;
};
